import { memo } from "react";
import { useTranslation } from "react-i18next";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface FilePreviewPdfPaginationProps {
  pageNumber: number;
  numPages: number;
  onPrevious: () => void;
  onNext: () => void;
  className?: string;
}

export const FilePreviewPdfPagination = memo(
  ({
    pageNumber,
    numPages,
    onPrevious,
    onNext,
    className,
  }: FilePreviewPdfPaginationProps) => {
    const { t } = useTranslation();

    return (
      <div className={cn("w-full", className)}>
        <div className="bg-white border-t border-slate-200 px-3 sm:px-4 py-1.5 flex items-center justify-between w-full overflow-x-hidden">
          <Button
            variant="ghost"
            size="sm"
            onClick={onPrevious}
            disabled={pageNumber <= 1}
            aria-label={t("filePreview.previousPage")}
            className="text-xs sm:text-sm text-slate-600 hover:text-slate-900 hover:bg-slate-50"
          >
            <ChevronLeft className="h-3 w-3 sm:h-4 sm:w-4" />
            <span>{t("common.previous")}</span>
          </Button>
          <span className="text-xs sm:text-sm text-slate-600 font-medium px-2">
            {pageNumber} / {numPages}
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={onNext}
            disabled={pageNumber >= numPages}
            aria-label={t("filePreview.nextPage")}
            className="text-xs sm:text-sm text-slate-600 hover:text-slate-900 hover:bg-slate-50"
          >
            <span>{t("common.next")}</span>
            <ChevronRight className="h-3 w-3 sm:h-4 sm:w-4" />
          </Button>
        </div>
      </div>
    );
  },
);
